// extracted by mini-css-extract-plugin
export var cartIcon = "_o6-0";
export var cartIconContainer = "_o6-1";